import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Tag, Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { LeadForm } from "../components/LeadForm";

export default function Offers() {
  const [copied, setCopied] = useState(null);
  const OFFERS = [
    { code: "FIRST100", title: "First Order Treat", desc: "Flat ₹100 off on your first order above ₹399.", color: "from-gold/20" },
    { code: "ROYAL20", title: "Royal Weekend", desc: "20% off (up to ₹150) on orders above ₹499.", color: "from-navy/10" },
    { code: "FEAST50", title: "Feast Saver", desc: "₹50 off on orders above ₹299.", color: "from-gold/15" },
  ];
  const copy = (code) => { navigator.clipboard.writeText(code); setCopied(code); toast.success(`Copied ${code}`); setTimeout(() => setCopied(null), 1500); };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="offers-page">
      <div className="text-center mb-8"><div className="overline text-gold">Save more</div><h1 className="font-serif text-4xl sm:text-5xl text-navy mt-1">Offers & Coupons</h1></div>
      <div className="grid sm:grid-cols-3 gap-5">
        {OFFERS.map((o) => (
          <div key={o.code} className={`rounded-2xl border border-gold/30 bg-gradient-to-br ${o.color} to-white p-6 card-hover`} data-testid={`offer-${o.code}`}>
            <Tag className="text-gold mb-3" size={22} />
            <h3 className="font-serif text-xl text-navy">{o.title}</h3>
            <p className="text-sm text-muted-foreground mt-1.5">{o.desc}</p>
            <button onClick={() => copy(o.code)} className="mt-4 flex items-center gap-2 w-full justify-between bg-navy text-cream px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-navy-soft transition-colors">
              <span className="tracking-wider">{o.code}</span>{copied === o.code ? <Check size={15} /> : <Copy size={15} />}
            </button>
          </div>
        ))}
      </div>
      <div className="text-center mt-8"><Link to="/menu" className="inline-flex bg-gold text-navy font-semibold px-7 py-3 rounded-full hover:bg-gold-light transition-colors">Start Ordering</Link></div>
      <div className="bg-white rounded-2xl border border-black/5 p-7 mt-12 max-w-xl mx-auto">
        <LeadForm source="Newsletter" title="Get exclusive offers" cta="Subscribe" fields={["name", "email", "phone"]} />
      </div>
    </div>
  );
}
